import { render, staticRenderFns } from "./FundCard.vue?vue&type=template&id=8360aefc&lang=pug"
import script from "./FundCard.vue?vue&type=script&lang=js"
export * from "./FundCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports